"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listGroup = void 0;

var _utils = require("./utils");

var listGroup = {
  padding: {
    left: '0'
  },
  margin: {
    bottom: '0'
  },
  border: {
    aLiFlushRight: '0',
    aLiFlushLeft: '0',
    aLiFlushFirstChildTop: '0',
    aLiFlushLastChildBottom: '0'
  },
  borderRadius: _utils.utils.borderRadius
};
exports.listGroup = listGroup;